import React from 'react';
import { Dropdown } from './StyledDropdown';
import { CountryResponse, StateResponse } from '@/api/tax-guide';

type CountryStateProps = {
  selectedCountry?: CountryResponse;
  countryList: Array<CountryResponse>;
  setCountry: (country: CountryResponse) => void;
  showState: boolean;
  selectedState?: StateResponse;
  setState: (state: StateResponse) => void;
};

export const CountryStateDropDown = (props: CountryStateProps): JSX.Element => {
  const {
    selectedCountry,
    countryList,
    setCountry,
    showState,
    selectedState,
    setState,
  } = props;
  return (
    <>
      <Dropdown
        label="Country"
        id={selectedCountry?.id ?? ''}
        options={countryList}
        handleChange={country => {
          const selectedCountry = countryList.filter(
            indexVal => indexVal.id === country,
          )?.[0];
          setCountry(selectedCountry);
        }}
        defaultText={'Select Country'}
      />
      {showState && selectedCountry?.states ? (
        <Dropdown
          label="States"
          id={selectedState?.id ?? ''}
          options={selectedCountry?.states}
          handleChange={stateValue => {
            const setSelectedState = selectedCountry.states?.filter(
              state => state.id === stateValue,
            )?.[0];
            if (setSelectedState) setState(setSelectedState);
            else setState({ id: '', name: '' });
          }}
          defaultText={'Select State'}
        />
      ) : (
        <></>
      )}
    </>
  );
};
